<template>
  <div>
    <div class="flex items-start justify-between gap-3">
      <div>
        <span class="text-xl font-semibold text-gray-900">{{ $gettext("Déclaration CTIF") }}</span>
        <p class="mt-1 text-sm text-gray-500">
          {{ $gettext("Générer une déclaration de soupçon BC/FT à transmettre à la CTIF.") }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="mt-4 inline-flex items-center gap-2 rounded-md border border-red-200 px-3 py-2 text-sm font-semibold text-red-600 shadow-sm hover:bg-red-400 hover:text-white"
      @click="open = true"
    >
      <ExclamationTriangleIcon class="h-4 w-4" />
      {{ $gettext("Préparer une déclaration") }}
    </button>

    <CtifDeclarationModal
      v-if="open"
      :resource-type="resourceType"
      :resource-id="resourceId"
      @close="open = false"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { ExclamationTriangleIcon } from "@heroicons/vue/24/outline";
import CtifDeclarationModal from "@/components/ctif/CtifDeclarationModal.vue";

defineProps({
  resourceType: { type: String, required: true },
  resourceId: { type: String, required: true },
});

const open = ref(false);
</script>
